import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { PlayerItemComponent } from './player-item.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
    ],
    declarations: [
        PlayerItemComponent
    ],
    exports: [
        PlayerItemComponent
    ]
})
export class PlayerItemModule { }
